// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"62e98b70","337":"8fffc835","453":"3154de31","455":"9c17162f"}[chunkId] + ".chunk.js";
};